import { render, staticRenderFns } from "./emissionReduce.vue?vue&type=template&id=2c1ac7ee"
import script from "./emissionReduce.vue?vue&type=script&lang=js"
export * from "./emissionReduce.vue?vue&type=script&lang=js"
import style0 from "./emissionReduce.vue?vue&type=style&index=0&id=2c1ac7ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports